import script from "./esDayModelForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./esDayModelForm.vue?vue&type=script&setup=true&lang=ts"

import "./esDayModelForm.vue?vue&type=style&index=0&id=5fac74fa&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fac74fa"]])

export default __exports__